import createReactComponent from '../createReactComponent';
export default createReactComponent('signal-circle', 'SignalCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M9 13.5v-3m3 4.5V9m3 4.5v-3","key":"svg-0"}]]);